import { environment } from '../../../../environments/environment';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Jackpot } from '../../../shared/models/jackpot.interface';
import { DataTableResource, DataTableTranslations, DataTable } from 'angular-datatables-all-versions';

@Component({
  selector: 'app-cagnottes-view',
  templateUrl: './cagnottes-view.component.html',
  styleUrls: ['./cagnottes-view.component.css']
})
export class CagnottesViewComponent implements OnInit {

  @ViewChild('dataTable', {static: true}) dataTable: DataTable;
  public jackpot: Jackpot;
  public isCompany = false;
  public site_url: string;
  public table_data = [];
  public table_data_resource: DataTableResource<Object>;
  public table_data_count = 0;
  public table_data_limit = 8;
  public limits = [8, 16, 32];

  public translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  }

  constructor(private route: ActivatedRoute) {
    this.jackpot = this.route.snapshot.data['data'][0];
    let charity_donations = this.jackpot.charity_donations;
    let quick_charity_donations = this.route.snapshot.data['data'][0].quick_charity_donations;
    let donations = charity_donations.concat(quick_charity_donations);
    donations.sort(function(a,b){
      return new Date(b['payment'].updated_at).getTime() - new Date(a['payment'].updated_at).getTime();
    });
    this.jackpot.charity_donations = donations;


    this.isCompany = 'ENTERPRISE' === this.jackpot.pot_type;
    this.table_data_resource = new DataTableResource(this.jackpot.charity_donations);
    this.table_data_count = this.table_data_resource['items'].length;
    this.site_url = environment.base_url;
  }

  ngOnInit() {
  }

  reload(params) {
    let newParams = {...params};
    this.table_data_resource.query(newParams).then(items => this.table_data = items);
  }
}
